import { displayNotification } from 'Actions/UiActions';
import { pathToRoot, pathToForumsIndex, pathToActiveTopics } from 'Utils/nav/NavHelpers';

export const CHANGE_USER_SETTINGS = 'CHANGE_USER_SETTINGS';

export function saveUserSettingsState( userSettings ) {
	return {
		type: CHANGE_USER_SETTINGS,
		userSettings
	};
}

/** User Settings Functions **/
export function saveSetting( userSettings ) {
	return ( dispatch ) => {
		dispatch( updateUserSettingsStorage( userSettings ) );
		dispatch( saveUserSettingsState( userSettings ) );
		displayNotification( 'success', 'Settings saved', { force: true, timeout: 1000 } );
	}
}

export function getSavedUserSettings() {
	try {
		// Let's take v2 and v3 settings and merge them taking priority v3
		let v2Settings = mapV2UserSettings( JSON.parse( window.localStorage.getItem( 'topify_local_settings' ) ) ), // Topify v2 settings
			v3Settings = JSON.parse( window.localStorage.getItem( 'topifyLocalSettings' ) ); // New Toify v3 settings
		return Object.assign( {}, v2Settings, v3Settings );
	} catch( e ) {
		topifyConsole.warn( 'Error loading localStorage: ', e );
	}
}

export function fixLandingPage( landingPage ) {
	try {
		if( landingPage === 'home' && process.env.config.section.home === false ) {
			return process.env.config.IndexRoute;
		}
	} catch( e ) {
		return landingPage;
	}
	return landingPage;
}

export function updateUserSettingsStorage( userSettings ) {
	return ( dispatch, getState ) => {
		try {
			let state = getState(),
				currentSettings = state.ui.userSettings,
				data = Object.assign( {}, currentSettings, userSettings, { timestamp: new Date().getTime() } );

			window.localStorage.setItem( 'topifyLocalSettings', JSON.stringify( data ) );
			topifyConsole.info( 'topify_local_settings saved' );
		} catch( e ) {
			topifyConsole.error( 'Error saving localStorage: topify_local_settings: ', e );
		}
	}
}

export function mapLoadingBehaviour( lb ) {
	let loading_behavior = {
		oldest: '1',
		newest: '2',
		unread: '3'
	};
	return loading_behavior[ lb ] ? loading_behavior[ lb ] : '1';
}

export function mapOnlineUsersLoadingBehaviour( lb ) {
	let loading_behavior = {
		recent: '0', // recent first
		az: '2', // username a -> z ( default )
		za: '1' // username z -> a
	};
	return loading_behavior[ lb ] ? loading_behavior[ lb ] : '2';
}

export function getPageSize() {
	return ( dispatch, getState ) => {
		let state = getState(),
			pageSizeOption = parseInt( state.ui.userSettings.pageSize ),
			pageSizeDesktop = state.ustate.pageSize ? state.ustate.pageSize : 10;
		return pageSizeOption === 0 ? pageSizeDesktop : pageSizeOption;
	}
}

/* Topify V2 uses a different set of values for settings */
function mapV2UserSettings( currentSettings ) {
	if( currentSettings ) {
		let translation = {
			show_attachment_thumbnails: 'showAttachmentsPreview',
			style_theme: 'styleTheme',
			font_size: 'fontSize',
			posts_per_page: 'pageSize'
		};

		Object.keys( currentSettings ).map( ( key ) => {
			let newKey = translation[ key ] ? translation[ key ] : key;
			currentSettings[ newKey ] = currentSettings[ key ];
			return key;
		});
	}
}

export function getLandingPage() {
	return ( dispatch, getState ) => {
		let state = getState(),
			landingPagePath = pathToRoot();

		switch( state.ui.userSettings.landingPage ) {
			case 'index':
				landingPagePath = pathToForumsIndex();
				break;
			case 'active':
				landingPagePath = pathToActiveTopics();
				break;
		}

		return landingPagePath;
	}
}


// WEBPACK FOOTER //
// ./src/actions/UserSettingsActions.js